import React from "react";

const Subscriptions = ({
  active,
  width = 20,
  height = 20,
}: {
  active: boolean;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 3.25C12.664 3.25 13 3.586 13 4V5.5H16.75C17.164 5.5 17.5 5.836 17.5 6.25V16C17.5 16.414 17.164 16.75 16.75 16.75H3.25C2.836 16.75 2.5 16.414 2.5 16V6.25C2.5 5.836 2.836 5.5 3.25 5.5H7V4C7 3.586 7.336 3.25 7.75 3.25H12.25ZM13 7H7V15.25H13V7ZM4 7V15.25H5.5V7H4ZM11.5 4.75H8.5V5.5H11.5V4.75ZM14.5 7V15.25H16V7H14.5Z"
        fill={` ${active ? "#2D96A7" : "#868C98"} `}
      />
    </svg>
  );
};

export default Subscriptions;
